<div class="text-xs">
  <button
    type="button"
    class="flex items-center gap-1.5 w-full text-left text-foreground-primary-40 hover:text-foreground-primary-100 transition-colors"
    (click)="toggleCollapsed()"
  >
    <span class="flex items-center gap-1.5">
      <span class="w-1.5 h-1.5 rounded-full bg-action-primary inline-block"></span>
      <span class="font-semibold">Thinking</span>
      @if (!part().complete) {
        <span class="inline-block w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin"></span>
      } @else {
        <span>{{ 'ai-assistant.thinking-part.thought-complete' | translate }}</span>
      }
    </span>
    <svg-icon class="ml-auto" [key]="collapsed() ? 'chevron-down-16' : 'chevron-up-16'" size="16" />
  </button>

  @if (!collapsed()) {
    <div class="mt-2 text-foreground-primary-80">
      <app-markdown [source]="part().text" />
    </div>
  }
</div>
